import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-delivery-router',
  templateUrl: './delivery-router.component.html',
  imports: [RouterOutlet],
})
export class DeliveryRouterComponent {
  constructor() {}
}
